import { injectGlobal } from 'styled-components';
import styledNormalize from 'styled-normalize';
import antdStyle from './antdStyle';
import basicStyles from './basicStyles';

injectGlobal`

    /* NORMALIZE STYLES */

    ${styledNormalize}

    /* BASIC STYLES */

    ${basicStyles}

    /* ANTD SPECIFIC OVERWRITES */

    ${antdStyle}


`;



// WEBPACK FOOTER //
// ./src/lib/theme/injectGlobal.js